<template>
  <form enctype="multipart/form-data">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ grade_subject_id ? 'Update' : 'Create' }} Grade Subject Mapping</p>
      </header>
      <div class="modal-card-body">
        <!--Loading-->
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <b-field label="Subject">
          <b-select v-model="grade_subject.subject" ref="subject" required expanded placeholder="Select subject here">
            <option v-for="subject in fetchSubjects" :key="subject._id" :value="subject._id">{{ subject.name }}</option>
          </b-select>
        </b-field>
        <b-field label="Grade">
          <b-select v-model="grade_subject.grade" ref="grade" required expanded placeholder="Select grade here">
            <option v-for="grade in fetchGrades" :key="grade._id" :value="grade._id">{{ grade.name }}</option>
          </b-select>
        </b-field>
        <b-field label="Remarks">
          <b-input ref="message" minlength="3" v-model="grade_subject.remarks" type="textarea"
            placeholder="Add any remarks"></b-input>
        </b-field>
        <b-field label="Status">
          <b-switch ref="status" v-model="grade_subject.status" type="is-success">{{ grade_subject.status ? 'Active' :
            'Non-Active'}}</b-switch>
        </b-field>

        <b-field v-if="grade_subject_id" label="Lock Status">
          <b-switch :value="grade_subject.is_locked" type="is-danger"
            @input="changeGradeSubjectLock()">{{ grade_subject.is_locked ? 'Locked' : 'Unlocked' }}</b-switch>
        </b-field>


        <!-- <div class="tags">
          <span
            v-for="(file_obj, edit_file_index) in editfiles"
            :key="`EDIT_FILE_${edit_file_index}`"
          >
            <span style="margin: 0 5px;" class="tag is-primary" v-if="!file_obj.is_deleted">
              {{$common.fileBasename(file_obj.name)}}
              <button
                class="delete is-small"
                type="button"
                @click="deleteExistingFile(edit_file_index)"
              ></button>
            </span>
          </span>
        </div> -->
        <!-- <b-field class="file">
          <b-upload v-model="announcementfiles" multiple>
            <a class="button is-dark">
              <b-icon icon="upload"></b-icon>
              <span>Add Files</span>
            </a>
          </b-upload>
          <span
            class="file-name"
            v-for="(file, file_index) in announcementfiles"
            :key="file_index"
          >{{file.name}}</span>
        </b-field> -->
        <button type="button" @click.prevent="proceed()" class="button is-success btn-center">{{ grade_subject_id ?
          'Update' : 'Create'}}</button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "set-grade-subject",
  data() {
    return {
      // announcementfiles: null,
      isLoading: false,
      grade_subject: {
        grade: null,
        subject: null,
        remarks: "",
        status: true,
        is_locked: false
        // editfiles: [],
      },
      lock_code: '5225'
    };
  },
  props: {
    grade_subject_id: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["getTeacherToken", "fetchCurrentGradeSubject", "fetchSubjects", "fetchGrades"]),
  },
  methods: {
    ...mapActions([
      "createGradeSubject",
      "updateGradeSubject",
      "loadGradeSubjectDetails",
      "loadSubjects",
      "loadGrades"
    ]),
    changeGradeSubjectLock() {
      this.$buefy.dialog.prompt({
        message: `Confirm Lock/Unlock ?`,
        inputAttrs: {
          placeholder: 'Enter Passcode',
          maxlength: 4
        },
        trapFocus: true,
        onConfirm: (value) => {
          if (value == this.lock_code) {
            this.grade_subject.is_locked = !this.grade_subject.is_locked
          } else {
            this.$buefy.toast.open({
              message: 'Invalid Passcode',
              type: 'is-danger'
            })
          }
        }
      })
    },
    deleteExistingFile(index) {
      this.editfiles[index].is_deleted = true;
    },
    proceed() {
      let is_validate = this.$refs.subject.checkHtml5Validity() && this.$refs.grade.checkHtml5Validity();
      if (is_validate) {
        this.isLoading = true;
        if (this.grade_subject_id) {
          //For editing a subject
          this.updateGradeSubject({
            id: this.grade_subject_id,
            grade_subject: this.grade_subject,
            token: this.getTeacherToken,
          })
            .then(() => {
              this.isLoading = false;
              this.$emit("over");
              this.$buefy.toast.open({
                message: "Grade Subject mapping updated successfully",
                type: "is-success",
              });
            })
            .catch((err) => {
              this.isLoading = false;
              this.$emit("over");
              this.$buefy.toast.open({
                message: err.response?.data?.msg || err.response?.data || "An error occurred",
                type: "is-danger",
              });
            });
        } else {
          //For creating a new subject
          this.createGradeSubject({
            grade_subject: this.grade_subject,
            token: this.getTeacherToken,
          })
            .then(() => {
              this.isLoading = false;
              this.$emit("over");
              this.$buefy.toast.open({
                message: "Grade Subject mapping created successfully",
                type: "is-success",
              });
            })
            .catch((err) => {
              this.isLoading = false;
              this.$emit("over");
              this.$buefy.toast.open({
                message: err.response?.data?.msg || err.response?.data || "An error occurred",
                type: "is-danger",
              });
            });
        }
      }
    },
  },
  async created() {
    this.loadGrades({
      token: this.getTeacherToken
    })
    this.loadSubjects({
      token: this.getTeacherToken
    })

    if (this.grade_subject_id) {
      this.isLoading = true;
      await this.loadGradeSubjectDetails({
        id: this.grade_subject_id,
        token: this.getTeacherToken,
      })
      for (let key in this.grade_subject) {
        if (Object.hasOwnProperty.call(this.fetchCurrentGradeSubject, key)) {
          // For ObjectId fields (grade, subject), extract the _id
          if (key === 'grade' || key === 'subject') {
            this.grade_subject[key] = this.fetchCurrentGradeSubject[key]._id ? this.fetchCurrentGradeSubject[key]._id : this.fetchCurrentGradeSubject[key]
          } else {
            // For primitive fields (status, is_locked, remarks), copy directly
            this.grade_subject[key] = this.fetchCurrentGradeSubject[key]
          }
        }
      }
      this.isLoading = false;
    }
  },
};
</script>
<style scoped></style>